import React from 'react'
import { cx } from '@/utils/strings'

export type GetExpandingBorderStyleProps = {
  borderSize?: 'sm' | 'md'
  borderColor?: 'Primary Blue' | 'Indigo Blue' | 'Light Blue' | 'White' | null
  zIndex?: 0 | -1
}

export type ExpandingBorderCardProps = React.HTMLAttributes<HTMLDivElement> &
  GetExpandingBorderStyleProps & {
    className?: string
    children: React.ReactNode
    disableHover?: boolean
  }

export const getExpandingBorderStyle = ({
  borderSize = 'md',
  borderColor = 'Primary Blue',
  zIndex = 0,
}: GetExpandingBorderStyleProps = {}) =>
  cx(
    'group relative md:before:content-[""]',
    'before:pointer-events-none before:absolute before:inset-0 before:box-border',
    'before:transition-[inset] before:duration-250 before:ease-in-out before:rounded-2xl',
    'md:hover:before:opacity-100',
    borderSize === 'sm' && 'before:border-10 md:hover:before:-inset-1',
    borderSize === 'md' && 'before:border-20 md:hover:before:-inset-1.5',
    borderColor === 'Primary Blue' && 'before:border-primaryBlue',
    borderColor === 'Light Blue' && 'before:border-bw-light-blue',
    borderColor === 'Indigo Blue' && 'before:border-indigoBlue',
    borderColor === 'White' && 'before:border-white',
    zIndex === -1 && 'before:-z-1',
    zIndex === 0 && 'before:z-0'
  )

export default function ExpandingBorderCard({
  className,
  children,
  disableHover,
  borderSize,
  borderColor,
  zIndex,
  ...rest
}: ExpandingBorderCardProps) {
  return (
    <div className={cx(!disableHover && getExpandingBorderStyle({ borderSize, borderColor, zIndex }), className)} {...rest}>
      {children}
    </div>
  )
}
